import Dispatcher from '../../dispatcher';
import { actions } from '../../constants/sidebar/actions';

export const show = () =>
    Dispatcher.handleSidebarAction({ type: actions.SHOW_LIGHT_BOX });

export const hide = () =>
    Dispatcher.handleSidebarAction({ type: actions.HIDE_LIGHT_BOX });
